module.exports = __webpack_public_path__ + "img/CTO_Bongo_Shadid 1.6d732a8f.png";